export default __webpack_public_path__ + "static/media/7E5B2101-B6D7-419C-B8CC-05D25DE87A0F_1_105_c.5a702c99.jpeg";